import { render, staticRenderFns } from "./InventoryListTab.vue?vue&type=template&id=b418a12e&scoped=true&lang=pug&"
import script from "./InventoryListTab.vue?vue&type=script&lang=js&"
export * from "./InventoryListTab.vue?vue&type=script&lang=js&"
import style0 from "./InventoryListTab.vue?vue&type=style&index=0&id=b418a12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b418a12e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VProgressLinear,VRow,VSpacer,VTab,VTabs})
